import React from 'react';
import Header from '../components/header'
import Footer from '../components/footer';
import { VerticalSeparator } from '../components/separators';
import { Container } from 'react-bootstrap';
import { useEffect } from 'react';
import './ratesPage.css';

const RatesPage = (props) => {

  const { selectedLanguage, handleLanguageChange } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header selectedLanguage={selectedLanguage} handleLanguageChange={handleLanguageChange} />
      <Container fluid='true' className="container" >
        <div >
          <h1 className='text-h-ratespage-class' style={{ textAlign: 'center' }}>{selectedLanguage === 'ita' ? "Tariffe" : "Rates"}</h1>
          <VerticalSeparator height={"2vw"}></VerticalSeparator>
          <p className='text-p-ratespage-class' style={{ textAlign: 'justify', marginLeft: '10px', marginRight: '10px' }}>
            {selectedLanguage === 'ita' ? "Le tariffe sono settimanali:" : "The rates are weekly:"}
            <br />
            <br />
            {selectedLanguage === 'ita' ? "- da un minimo di 400,00 euro in bassa stagione" : "- starting from a minimum of 400.00 euros in low season"}
            <br />
            {selectedLanguage === 'ita' ? "- ad un massimo di 1200,00 euro in alta stagione" : "- up to a maximum of 1200.00 euros in high season"}
            <br />
            <br />
            {selectedLanguage === 'ita' ? "Siamo comunque disponibili, ad eccezione delle settimane centrali di agosto, anche a soluzioni diverse con soggiorni minimo di tre notti." : "We are, however, available for alternative solutions with a minimum stay of three nights, except for the central weeks of August."}
            <br />
            <br />
            {selectedLanguage === 'ita' ? "Le tariffe includono:" : "The rates include:"}
            <br />
            {selectedLanguage === 'ita' ? "- Pulizia iniziale e finale dell'appartamento" : "- Initial and final cleaning of the apartment"}
            <br />
            {selectedLanguage === 'ita' ? "- Corredo della cucina (pentole e stoviglie)" : "- Kitchen equipment (pots and dishes)"}
            <br />
            {selectedLanguage === 'ita' ? "- Ricambi settimanali di lenzuola" : "- Weekly change of bed linen"}
            <br />
            {selectedLanguage === 'ita' ? "- Ricambi settimanali di biancheria per il bagno (viso, ospite e telo doccia)" : "- Weekly change of bathroom linen (face towel, guest towel, and bath towel)"}
            <br />
            {selectedLanguage === 'ita' ? "- Consumi utenze (acqua, luce, gas)" : "- Utility consumption (water, electricity, gas)"}
            <br />
            {selectedLanguage === 'ita' ? "- Uso del barbecue a carbonella" : "- Use of charcoal barbecue"}
            <br />
            {selectedLanguage === 'ita' ? "- Lettino da campeggio, seggiolone e passeggino (se richiesti alla prenotazione)" : "- Camping cot, high chair, and stroller (if requested at the time of booking)"}
          </p>
          <VerticalSeparator height={"1vw"}></VerticalSeparator>
        </div>
      </Container>
      <Footer />
    </>
  );
}

export default RatesPage;